import * as actions from "../action.constants";

const initialState = {
  isLoading: false,
  addressListData: {},
  addressDropdown: [],
};

const storeAddressList = (state, action) => {
  return {...state, addressListData: action.payload || {}};
};

const handlers = {
  [actions.STORE_ADDRESS]: storeAddressList,
};

export default (state = initialState, action) => {
  const handler = handlers[action.type];
  if (typeof handler === "undefined") return state;
  return handler(state, action);
};
